import { render, staticRenderFns } from "./AddressResidence.vue?vue&type=template&id=4231bea8&"
import script from "./AddressResidence.vue?vue&type=script&lang=js&"
export * from "./AddressResidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports